import axios from '@/libs/axios';
import { useMutation } from '@tanstack/react-query';
import { MutationConfig } from '@/libs/react-query';

export * from './use-upload-url';

interface Request {
  document: File;
}

interface Response {
  status: number;
  data: {
    url: string;
  };
}

export async function request(data: Request): Promise<Response> {
  return axios.post('/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

type UseRequestOptions = {
  config?: MutationConfig<typeof request>;
};

export const useUpload = ({ config }: UseRequestOptions = {}) => {
  return useMutation({
    mutationFn: request,
    ...config,
  });
};
